export default "__VITE_ASSET__CfvMvuUj__"